import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { RaceIndicator } from 'src/domains/sportsbook/webview/components/raceIndicator/RaceIndicator';
import { BogIcon } from 'src/domains/sportsbook/webview/components/raceIndicator/icons/BogIcon';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const BogIndicator = observer('BogIndicator', () => {
    const common = useCommon();
    const { raceCardBogFullLabel } = ConfigComponents.get(common).config;

    return (
        <RaceIndicator
            key='star-bog-indicator'
            size='medium'
            variant='primary'
            dataTest='bog-indicator-race'
            label={
                raceCardBogFullLabel === true ? (
                    <I18n
                        langKey='events.bog-full'
                        defaultText='Best Odds Guaranteed'
                    />
                ) : (
                    <I18n
                        langKey='events.bog'
                        defaultText='BOG'
                    />
                )
            }
        >
            <BogIcon />
        </RaceIndicator>
    );
});
